import axios from '@/libs/axios'
import updateAbility from '@/libs/acl/utils'
import { initialAbility } from '@/libs/acl/config'
import { clearCompanyWindowGlobals } from '@/libs/companyGlobals'

let bootstrapPromise = null

export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    users: [],
    bootstrapped: false,
  },

  getters: {
    authenticated(state) {
      console.log('state=', state);
      return state.authenticated
    },

    user(state) {
      return state.user
    },

    users(state) {
      return state.users
    },

    bootstrapped(state) {
      return state.bootstrapped
    },
  },

  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value
    },

    SET_USER(state, value) {

      state.user = value
      console.log('state set =', state);
      console.log('value set =', value);
    },

    SET_BOOTSTRAPPED(state, value) {
      state.bootstrapped = Boolean(value)
    },

    SET_USERS(state, value) {
      state.users = value
    },

    UPDATE_USER(state, userData) {
      if (userData.card && typeof userData.card === 'string') {
        userData.card = JSON.parse(userData.card)
      }
      Object.assign(state.user, userData)
    },

    UPDATE_USER_EDITED(state, userData) {
      const index = state.users.findIndex(user => user.id === userData.id);
      if( index >= 0 ){
        Object.assign(state.users[index], userData);
      }
    },

    ADD_USER(state, userData) {
      userData.role = userData.role_name;
      state.users.push(userData);
    },
    SET_ACTIVE_CARD(state, value) {
      state.user.card = value
    }
  },

  actions: {
    async login({ dispatch }, { credentials, ability }) {
        //await axios.get('sanctum/csrf-cookie');
        return axios.post('/api/login', credentials,{
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
          }
        });
    },

    async logout({ commit }, ability) {
      try {
        const { stopSessionWatch } = await import('@/libs/sessionWatch')
        stopSessionWatch()
        await axios.get('sanctum/csrf-cookie')
        await axios.post('logout')
      } finally {
        commit('SET_AUTHENTICATED', false)
        commit('SET_USER', null)
        commit('modulesRegistry/CLEAR_MODULES', null, { root: true })
        clearCompanyWindowGlobals()
        if (ability) {
          ability.update(initialAbility)
        }
      }
    },

    async register({ dispatch }, payload) {
      // Support both { credentials, ability } (same as login) and a flat payload from callers
      const credentials = payload.credentials ?? payload
      const ability = payload.ability

      console.log('credentials=', credentials);
      await axios.post('/register', credentials)

      return dispatch('loadUser', ability)
    },

    async recovery(_, credentials) {
      await axios.get('sanctum/csrf-cookie')
      return axios.post('forgot-password', credentials)
    },

    async reset(_, credentials) {
      await axios.get('sanctum/csrf-cookie')
      return axios.post('reset-password', credentials)
    },

    async sanctum({ commit }, ability) {
      await axios.get('sanctum/csrf-cookie');
      return true;
    },

    // Single shared boot probe so the UI can mount without waiting, while guards can await it.
    bootstrap({ dispatch, state, commit }, ability) {
      if (state.bootstrapped) {
        return Promise.resolve(state.user)
      }
      if (!bootstrapPromise) {
        bootstrapPromise = dispatch('loadUser', ability)
          .finally(() => {
            commit('SET_BOOTSTRAPPED', true)
            bootstrapPromise = null
          })
      }
      return bootstrapPromise
    },

    ensureBootstrapped({ dispatch, state }, ability) {
      if (state.bootstrapped) {
        return Promise.resolve(state.user)
      }
      return dispatch('bootstrap', ability)
    },

    async loadUser({ commit }, ability) {

      return axios.get('api/user', { skipSessionRedirect: true }).then(response => {
        commit('SET_AUTHENTICATED', true)
        commit('SET_USER', response.data.data)
        updateAbility(response.data.data, ability);
        return response.data.data;
      }).catch(() => {
        commit('SET_AUTHENTICATED', false)
        commit('SET_USER', null)
        clearCompanyWindowGlobals()
        if (ability) {
          ability.update(initialAbility)
        }
        return null;
      })
    },

    loadUsers({ commit }) {
      return axios.get('api/users').then(response => {
        commit('SET_USERS', response.data.data)
      })
    },

    deleteUser(_, credentials) {
      //return axios.post('api/user', credentials)
    },
    createUser(_, credentials) {
      return axios.post('api/user', credentials);
    },
    createAdminUser({ commit }, credentials) {
      return axios.post('api/user', credentials).then((response)=>{
        commit('ADD_USER', response.data);
      })
    },
    updateUser({ commit }, data) {

      return axios.post(`api/user/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data && response.data.data) {
          commit('UPDATE_USER', response.data.data)
        } else {
          commit('UPDATE_USER', Object.fromEntries(data))
        }
        commit('UPDATE_USER_EDITED', response.data.data);
      })
    },
    changePassword({ commit }, payload) {
      return axios.post('api/user/change-password', payload).then((response) => {
        if (response.data?.data) {
          commit('UPDATE_USER', response.data.data)
        }
        return response.data
      })
    },
    verifyEmailCode(_, { code }) {
      return axios.post('api/email/verify-code', { code })
    },
    resendEmailCode() {
      return axios.post('api/email/resend-code')
    },
  },
}
